import { RxEventEmitter } from '@bimser/core';
import { PartialObserver } from 'rxjs';
import { Entities } from '../exports';

type EventEmitterEmitArgs = {
	name: Entities.EventEmitterTypes;
	data?: unknown;
};

type EventEmitterListenArgs = {
	name: Entities.EventEmitterTypes;
	handler: PartialObserver<unknown>;
};

export class EventEmitter {
	static emit(dataGrid: Entities.DataGrids, args: EventEmitterEmitArgs | EventEmitterEmitArgs[]) {
		if (Array.isArray(args)) {
			return Promise.all(
				args.map(emit => RxEventEmitter.emit(`${dataGrid}_${emit.name}`, emit.data))
			);
		} else {
			return RxEventEmitter.emit(`${dataGrid}_${args.name}`, args.data);
		}
	}

	static listen(
		dataGrid: Entities.DataGrids,
		args: EventEmitterListenArgs | EventEmitterListenArgs[]
	) {
		if (Array.isArray(args)) {
			args.forEach(listen => {
				RxEventEmitter.listen(`${dataGrid}_${listen.name}`, listen.handler);
			});

			return () => {
				args.forEach(listen => this.dispose(dataGrid, listen.name));
			};
		} else {
			RxEventEmitter.listen(`${dataGrid}_${args.name}`, args.handler);

			return () => this.dispose(dataGrid, args.name);
		}
	}

	static dispose(dataGrid: Entities.DataGrids, name: Entities.EventEmitterTypes) {
		const subjectId = RxEventEmitter.createName(`${dataGrid}_${name}`);
		if (RxEventEmitter.subjects[subjectId]) {
			RxEventEmitter.subjects[subjectId].unsubscribe();
			delete RxEventEmitter.subjects[subjectId];
		}
	}
}
